import Hls from 'hls.js'

const live = document.querySelector('[js-live]')
const img = document.querySelector('[js-live-img]')
const liveBtn = document.querySelector('[js-live-btn]')
const startBtn = document.querySelector('[js-live-play]')
const stopBtn = document.querySelector('[js-live-stop]')
const muteBtn = document.querySelector('[js-live-mute]')
const fullBtn = document.querySelector('[js-live-fullscreen]')
const closeBtn = document.querySelector('[js-live-close]')
const bottom = document.querySelector('[js-live-bottom]')

let options = {
  play: false,
  muted: false,
  full: false
}

if (live) {
  if (Hls.isSupported()) {
    const hls = new Hls();
    hls.attachMedia(live);
    hls.on(Hls.Events.MEDIA_ATTACHED, () => {
      hls.loadSource(
        'https://streamtv.cdn.dvmr.fr/TV78/ngrp:tv78.stream_all/master.m3u8'
      );
    });
  } else {
    let isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    if (isIOS) {
      live.src = 'https://streamtv.cdn.dvmr.fr/TV78/ngrp:tv78.stream_all/master.m3u8'
    }
  }

  liveBtn.addEventListener('click', () => {
    live.muted = false;
    live.play()
    img.style.display = 'none';
    liveBtn.style.display = 'none';
    options.play = true
    bottom.classList.add('is-appear')
  })

  startBtn.addEventListener('click', () => {
    live.muted = false;
    startBtn.classList.remove('is-pause')
    stopBtn.classList.remove('is-pause')
    live.play()
    options.play = true
  })

  live.addEventListener('click', () => {
    if (options.play) {
      live.muted = false;
      startBtn.classList.remove('is-pause')
      stopBtn.classList.remove('is-pause')
      live.play()
    } else {
      live.muted = false;
      startBtn.classList.add('is-pause')
      stopBtn.classList.add('is-pause')
      live.pause()
    }
    options.play = !options.play
  })

  stopBtn.addEventListener('click', () => {
    live.muted = false;
    startBtn.classList.add('is-pause')
    stopBtn.classList.add('is-pause')
    live.pause()
    options.play = false
  })

  muteBtn.addEventListener('click', () => {
    live.muted = !options.muted
    options.muted = !options.muted
    if (options.muted) muteBtn.classList.add('is-muted')
    else muteBtn.classList.remove('is-muted')
  })

  fullBtn.addEventListener('click', openFullscreen)

  /* View in fullscreen */
  function openFullscreen() {
    if (live.requestFullscreen) {
      live.requestFullscreen();
    } else if (live.webkitRequestFullscreen) { /* Safari */
      live.webkitRequestFullscreen();
    } else if (live.msRequestFullscreen) { /* IE11 */
      live.msRequestFullscreen();
    }
  }
}